import { Lean } from '@fiverr-private/header/';

export default Lean;
